// Copied from Firefish: packages/app/src/features/borrowing/components/interest/summary/getSummaryData.ts

import { Currency } from '../types/currency';
import { LoanType } from '../types/loanType';
import {
  getAmountDue,
  getBitcoinCollateral,
  getBitcoinToSend,
  getFiatOriginationFee,
  getOriginationFee,
} from './loanCalculations';

const LTV_0 = 50; // from Firefish config.loanRequestForm.ltv0

interface SummaryDataInput {
  amount: string;
  period: number;
  currency: Currency;
  loanType: LoanType;
  customInterestRate: string;
  instantRate: string | undefined;
  originationFeeRate: string;
  bitcoinPrice: string | undefined;
}

interface SummaryData {
  amount: string;
  interestRate: string;
  period: number;
  currencyCode: Currency;
  isInstant: boolean;
  amountDue: string;
  originationFee: string;
  btcCollateral: string;
  btcTotal: string;
}

export function getSummaryData(input: SummaryDataInput): SummaryData | null {
  const {
    loanType,
    customInterestRate,
    instantRate,
    amount,
    period,
    currency,
    originationFeeRate,
    bitcoinPrice,
  } = input;

  const isInstant = loanType === LoanType.Instant;
  const interestRate = isInstant ? instantRate : customInterestRate;

  if (
    loanType === LoanType.None ||
    !interestRate ||
    !amount ||
    !period ||
    !currency ||
    !originationFeeRate ||
    !bitcoinPrice
  ) {
    return null;
  }

  const amountDue = getAmountDue(amount, interestRate, period).toString();

  const originationFee = getOriginationFee(
    bitcoinPrice,
    getFiatOriginationFee(amount, originationFeeRate, period)
  );

  const btcCollateral = getBitcoinCollateral(
    amountDue,
    bitcoinPrice,
    LTV_0
  );
  const btcTotal = getBitcoinToSend(originationFee, btcCollateral);

  return {
    amount,
    interestRate,
    period,
    currencyCode: currency,
    isInstant,
    amountDue,
    originationFee,
    btcCollateral,
    btcTotal,
  };
}
